/* eslint-disable @nx/enforce-module-boundaries */
import { Route } from '@angular/router';
import { authActivateGuard } from '@t-llevo/auth';
import { AdminLayoutComponent } from '@t-llevo/layout';
import versionControlRoutes from './version-control/version-control-routes';
import summaryRoutes from './summary/summary-routes';
import travelRoutes from './travel/travel-routes';
import driverRoutes from './driver/driver-routes';
import userRoutes from './user/user-routes';
import vehicleTypesRoutes from './vehicle-types/vehicle-types-routes';
import clientRoutes from './client/client-routes';
import travelPricingRoutes from './travel-pricing/travel-pricing-routes';

export const appRoutes: Route[] = [
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [authActivateGuard],
    children: [
      {
        path: '',
        redirectTo: 'summary',
        pathMatch: 'full',
      },
      {
        path: 'drivers',
        children: driverRoutes,
      },
      {
        path: 'vehicles',
        children: vehicleTypesRoutes,
      },
      {
        path: 'user',
        children: userRoutes,
      },
      {
        path: 'version-control',
        children: versionControlRoutes,
      },
      {
        path: 'summary',
        children: summaryRoutes,
      },
      {
        path: 'travel',
        children: travelRoutes,
      },
      {
        path: 'travel-pricing',
        children: travelPricingRoutes,
      },
      {
        path: 'client',
        children: clientRoutes,
      },
    ],
  },
  {
    path: 'seguridad',
    loadChildren: () => import('libs/angular/auth/src/lib/auth-routes'),
  },
];
